// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--W3Ozk","banner":"_0bc5e8de02--banner--PVLhM","text":"_0bc5e8de02--text--g6OW1"};